import { css, media, styled } from '@nx-kit/styling';

export const RowFilterStyled = styled.div<{ noGap?: boolean }>`
  display: flex;
  margin: 30px 0 60px;
  flex-direction: column;

  ${media('lg')} {
    align-items: center;
    ${(noGap) =>
      !noGap &&
      css`
        justify-content: space-between;
      `}

    flex-direction: row;
  }
`;

export const RowSortStyled = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  flex-direction: column;

  ${media('md')} {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const SortGroupStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  gap: 0.5rem;
  ${media('md')} {
    margin: 0;
  }
`;

export const SortGroupWithSpaceStyled = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
`;

export const ResultsCounterStyled = styled.div`
  color: ${({ theme }) => theme.global.color.gray180};
`;

export const SpacerStyled = styled.div`
  margin: 0 10px;
`;
